import * as React from "react";

import {useIntersectionObserver} from "../hooks";
import {ResponseProductDinkus} from "../model";

interface ProductImageSlideProps {
  src: string | undefined;
  alt: string | undefined;
  dinkus?: ResponseProductDinkus;
}

const SpecialProductLoadingGraphic: React.FunctionComponent = () => {
  return (
    <div className="o-loading__loader">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export const getImageAltFromUrl = (
    url: string | URL
) => {
  const urlObject = new URL(url);
  const fileName = urlObject.pathname.split('/').pop();
  if (fileName) {
    const cleanFileName = fileName.split('?')[0].split('#')[0];
    const decodedFileNameWithExt = decodeURIComponent(cleanFileName);
    const fileNameWithSpaces = decodedFileNameWithExt.replace(/\.[^/.]+$/, '');
    return fileNameWithSpaces.replace(/-/g, ' ');
  }

  return '';
};

export const ProductImageSlide: React.FunctionComponent<
  ProductImageSlideProps
> = (props) => {
  const [ref, entry] = useIntersectionObserver();

  const [hasLoaded, setHasLoaded] = React.useState(false);

  const onImageLoaded = () => {
    setHasLoaded(true);
  };
  const onImageLoadingError = () => {
    setHasLoaded(true);
  };

  const showImage = entry?.isIntersecting || hasLoaded;

  const dinkus = React.useMemo(() => {
    if (!props.dinkus) {
      return null;
    }
    return Object.entries(props.dinkus).map(([key, value]) => {
      if (!value || (value as string).length < 1) {
        return null;
      }

      const alt = getImageAltFromUrl(value);

      return <img key={key} className={`plp-dinkus plp-${key}`} alt={alt} src={value} width="76px" height="32px" />;
    });
  }, [props.dinkus]);

  return (
    <div ref={ref} className="bbnt-product-image-slide">
      {showImage && (
        <React.Fragment>
          <img
            src={props.src}
            alt={props.alt}
            onLoad={onImageLoaded}
            onError={onImageLoadingError}
            width="300px"
            height="300px"
          />
        </React.Fragment>
      )}

      {dinkus}

      {showImage && (
        <React.Fragment>
          <div className="hovering-overlay" />
        </React.Fragment>
      )}

      {!hasLoaded && <SpecialProductLoadingGraphic />}
    </div>
  );
};
